import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: { name: string; check: boolean } = {
  name: "event",
  check: false,
};
const validationSlice = createSlice({
  name: "validate",
  initialState,
  reducers: {
    checkForValidation: (
      _,
      action: PayloadAction<{ name: string; check: boolean }>
    ) => {
      return action.payload;
    },
  },
});

export const { checkForValidation } = validationSlice.actions;

export default validationSlice.reducer;
